import decodeJwt from 'jwt-decode';
import { fetchUtils } from 'react-admin';

const fetchJson = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    // add your own headers here
    try {
      let a = decodeJwt(localStorage.getItem("token")).access_token
      options.headers.set('Authorization', a);
    } catch { }
    return fetchUtils.fetchJson(url, options);
  }

export default fetchJson;